module.exports = __webpack_public_path__ + "img/h5bg.6fc67014.png";